import React from 'react'
import PropTypes from 'prop-types'
import styles from 'modules/AccountsMarketplace/Categories/subcomponents/CategoriesList/categories-list.module.scss'
import { Button, Col, Grid, NetworkIcon, Typography } from 'gu-ui-kit'
import clsx from 'clsx'
import { ROUTES } from 'constants/routes'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useTranslation } from 'react-i18next'
import GridSpinner from 'components/UI/GridSpinner'

const CategoriesList = ({ items, loading }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()

  return loading ? (
    <GridSpinner width={24} />
  ) : (
    <Grid gap={16} className={styles['list__container']}>
      {items.map((category) => (
        <Col sm="6" s="12" md="6" ls="4" xl="3" key={'category-' + category.id}>
          <Grid
            className={clsx(
              styles['list__item'],
              styles['list__item-palette-light'],
            )}
            component={Link}
            to={pathGen(ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY, {
              categoryId: category.id,
            })}
          >
            <Grid gap={16} alignItems={'center'} wrap={false}>
              <NetworkIcon name={category.type} size={'m'} width={56} rounded />
              <Typography variant={'Subtitle-30'} color={'Label-Primary'}>
                {category.name}
              </Typography>
            </Grid>
            <Grid gap={16} direction={'column'}>
              {!!category?.order_products_count && (
                <Grid gap={4} alignItems={'baseline'}>
                  <Typography variant={'Body-Accent-40'} color={'Label-Fifth'}>
                    {category.order_products_count}
                  </Typography>
                  <Typography
                    variant={'Body-Accent-10'}
                    color={'Label-Secondary'}
                  >
                    {t('accounts_marketplace::categories_list.item.purchased', {
                      count: category.order_products_count,
                    })}
                  </Typography>
                </Grid>
              )}

              <div>
                <Button
                  size={'s'}
                  variant={'ghost'}
                  grey
                  className={styles['accounts-link']}
                >
                  {t(
                    'accounts_marketplace::categories_list.item.to_account_list',
                  )}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Col>
      ))}
    </Grid>
  )
}

export default CategoriesList

CategoriesList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.array,
}
